<template>
  <div class="nav-bar">
    <div class="nav">
      <ul class="nav-list-items">
        <li class="nav-list-item"><router-link to="/contact">Contact</router-link></li>
        <li class="nav-list-item"><router-link to="/about">About Me</router-link></li>
        <li class="nav-list-item"><router-link to="/home">Home</router-link></li>
        <li class="nav-title"> <router-link to="/home">MITCH FITZSIMMONS</router-link></li>
      </ul>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Navbar"
    }
</script>

<style scoped>

  * {
    margin: 0;
    padding: 0;
  }

  .nav-bar {
    height: 60px;
    background-color: #262B39;

  }
  li {
    display: inline;
    padding-left: 0px;
    float: right;
  }
  ul.nav-list-items {
    position: fixed;
    top: 0;
    width: 100%;
    position: -webkit-sticky; /* Safari */
    position: sticky;
  }
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    height: 60px;
  }
  li.nav-title a {
    display: block;
    color: white;
    text-align: center;
    text-decoration: none;
    font-family: SignPainter;
    font-size: 38px;
    height: 60px;
    line-height: 60px;
    padding-left: 12px;
  }
  li.nav-title{
    float: left;
  }
  li.nav-list-item a {
    height: 60px;
    line-height: 60px;
    display: block;
    color: white;
    text-align: center;
    padding-right: 16px;
    padding-left: 16px;
    text-decoration: none;
    font-family: "HelveticaNeue-Light";
    font-variant: li;
  }

  li.nav-list-item a:hover:not(.active) {
    background-color: #111;
  }
  .active {
    background-color: #4CAF50;
  }

</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue